import Layout from './layout'
import Links from './links'
import StaticFormFieldEntries from './contact-form'
import Cookies from './cookies'

export default { Layout, Links, StaticFormFieldEntries, Cookies }
